import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminSesionAlarmaComponent {
  constructor ($interval, $session) {
    this.$interval = $interval
    this.$session = $session
    this.expiracion = null
    this.onCancel = null
    this.procesando = false
    this.interval = null
    this.expires_in = 0
  }

  $onInit () {
    this.interval = this.$interval(() => (this.updateTime()), 1000)
    this.updateTime()
  }

  $onDestroy () {
    this.$interval.cancel(this.interval)
  }

  cancelar () {
    this.onCancel()
  }

  validar () {
    this.procesando = true
    this.$session.renew()
  }

  updateTime () {
    this.expires_in = Math.round((this.expiracion.getTime() - new Date().getTime()) / 1000)

    if (this.expires_in <= 0) {
      this.$interval.cancel(this.interval)
      this.cancelar()
    }
  }
}

module.component('fanconsultoresAdminSesionAlarma', {
  controller: FanconsultoresAdminSesionAlarmaComponent,
  template,
  bindings: {
    expiracion: '<',
    onCancel: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/sesion/alarma/component.js